/**
 * @prettier
 */
import { CompanyNameOption, KEY_NAME } from 'src/localStorage/getCompanyNameOptionsInLocalStorage';

export function setCompanyNameOptionsInLocalStorage(value: Array<CompanyNameOption>): void {
    window.localStorage.setItem(KEY_NAME, JSON.stringify(value));
}
